import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent, useIonViewDidLeave } from '@ionic/react'
import { decorationMobx, advertMobx, themeMobx, memberMobx, memberCardMobx, authConfigMobx, storeMobx } from '@mobxStore'
import { useHistoryNew, getPlatform, alertLayer, checkInVisible, setCSSProperty, diyStyle } from '@utils'
import { cartMobx, restaurantConfig } from 'restaurant'
import { thirdConfigG } from 'controllers/third'
import { getNickName } from '@common/utils/member'
import { Advert } from '@cps'
import mktController from 'controllers/mktController'
import { getLevelUpGrowth } from 'common/utils/member'
import { LanguageSwitch } from '../'
import MemberCard from './MemberCard'
import MemberInfo from './MemberInfo'
import FreeGetCard from './FreeGetCard'
import PointsCardLayout from './PointsCardLayout'
import { format, toPrice, getParams, useThrottle } from '@dt/fe-utils'
import Notice from '../Notice'
import './index.scss'

import memberImg from '@img/member/member.png'

interface IProps {
}

/** 首页DIY模板 */
const HomeDiy: React.FC<IProps> = (props) => {
  const { homeDecorates, diyMemberCardInfo } = decorationMobx
  const { bestDiscountCard } = memberCardMobx
  const availableAdsMap = advertMobx.availableAdsMap as any
  const history = useHistoryNew()

  // 扫码
  const _handleScan = () => {
    thirdConfigG().scan(str => {
      if (str) {
        const { ct, b, s, t } = getParams({ url: str })
        if (!!ct && !!b && !!s && ((!!t && ct === 'table') || ct === 'store') && Number(b) === Config.BRANDID) {
          location.replace(str)
        } else {
          alertLayer(i18n.t('menu.scanCodeTip'))
        }
      }
    })
  }

  const handleGo = (type: string) => {
    mktController.checkLogin(history).then(() => {
      history.push('/iCoupon/coupon/' + type)
    })
  }

  // 背景图样式处理
  const handleBgStyle = (data: IBacbackgroundImage) => {
    const { width = 0, height = 0 } = data || {}
    return height ? {
      height: `calc(${Number(height) / Number(width || 1) * 100}vw)`
    } : {}
  }

  // 渲染会员营销项
  const handleRenderMemberItem = (data: IDiyModule, index: number) => {
    const { typeExtraContent, type } = data
    let getCnt: number = 0
    if (type === 'myCoupons_get') {
      memberMobx.unacquiredCoupons.forEach((item) => {
        item.coupons.forEach((coupon) => {
          getCnt += coupon.couponCnt
        })
      })
    }
    const buyCard = (e: any) => {
      e.stopPropagation()
      if (bestDiscountCard) {
        mktController.checkLogin(history).then(() => {
          if (bestDiscountCard.type === 'default') {
            history.push('/memberCard')
          } else {
            history.push(`/iCard/cardOpen/open/${bestDiscountCard.cardId}`)
          }
        })
      }
    }
    const getCost = () => {
      const levelInfo = diyMemberCardInfo?.card
      let cost = 0
      if (levelInfo) {
        const growth = getLevelUpGrowth(levelInfo.nextLevelInfo.levelGrowth, diyMemberCardInfo.growth)
        if (levelInfo.consumeGrowthGet) {
          cost = growth * levelInfo.consumeGrowth / levelInfo.consumeGrowthGet
        } else if (levelInfo.rechargeGrowthGet) {
          cost = growth * levelInfo.rechargeGrowth / levelInfo.rechargeGrowthGet
        } else if (levelInfo.mallGrowthGet) {
          cost = growth * levelInfo.mallGrowth / levelInfo.mallGrowthGet
        }
      }
      return toPrice(cost, 2)
    }
    const getDisCount = () => {
      const nextLevelInfo = diyMemberCardInfo?.card?.nextLevelInfo
      let text = ''
      if (nextLevelInfo) {
        if (nextLevelInfo.discountType) {
          if (nextLevelInfo.discountType === 'discountRate') {
            text = `${i18n.t('order.meals')}${format.toDiscount('discountRate', nextLevelInfo?.discountValue)}`
          } else if (nextLevelInfo.discountType === 'memberPrice') {
            text = `${i18n.t('order.meals')}${i18n.t('checkout.memberPrice')}`
          }
        } else if (nextLevelInfo.mallDiscountType) {
          if (nextLevelInfo.mallDiscountType === 'discountRate') {
            text = `${i18n.t('order.mall')}${format.toDiscount('discountRate', nextLevelInfo?.mallDiscountValue)}`
          } else if (nextLevelInfo.mallDiscountType === 'memberPrice') {
            text = `${i18n.t('order.mall')}${i18n.t('checkout.memberPrice')}`
          }
        }
      }
      return text
    }
    const goSetting = () => {
      if (authConfigMobx.isNoWorry) {
        history.push('/my/setting')
      }
    }
    const handleGoToLvDetail = () => {
      memberMobx.updateHasShowLvInfo(false)
      history.push('my', { cardId: diyMemberCardInfo.cardId })
    }
    return (
      <>
        {
          type === 'memberBenefits' && typeExtraContent?.memberCard &&
            <>
              {
                !memberMobx.cardListForMy.length
                  ? (
                    <FreeGetCard
                      isPaid={bestDiscountCard?.type === 'paid'}
                      cardInfo={typeExtraContent.memberCard}
                      color={typeExtraContent.memberCard.color}
                      buyCard={buyCard}
                    />
                  )
                  : <MemberCard cardList={memberMobx.cardListForMy} cardInfo={typeExtraContent.memberCard}></MemberCard>
              }
            </>
        }
        {type === 'memberInfo' && typeExtraContent?.memberInfo && <MemberInfo memberInfo={memberMobx.memberInfo} info={typeExtraContent.memberInfo}></MemberInfo>}
        {type === 'memberPointsCard' && typeExtraContent?.memberPointInfo && memberMobx.isLogin && <PointsCardLayout pointInfo={typeExtraContent.memberPointInfo}></PointsCardLayout>}
        {type === 'memberInfo_avatar' &&
          <div data-cypid='mmgToSetting' className='new-diy-member-info' onClick={goSetting}>
            {
              !memberMobx.memberInfo.avatarUrl && memberMobx.memberInfo.nickName ? (
                <div className='diy-member-info-nickname' style={{ width: `${typeExtraContent.fontSize}px`, height: `${typeExtraContent.fontSize}px` }}>
                  <span>{memberMobx.memberInfo.nickName?.charAt(0)?.toUpperCase()}</span>
                </div>
              ) : (
                <div className='diy-member-info-img' style={{ backgroundImage: `url(${memberMobx.memberInfo?.avatarUrl || memberImg})`, ...diyStyle({ width: typeExtraContent.fontSize, height: typeExtraContent.fontSize }) }}></div>
              )
            }
          </div>}
        {type === 'memberInfo_name' && <div data-cypid='mmgToSetting' onClick={goSetting} style={{ fontSize: `${typeExtraContent.fontSize}px`, color: `${typeExtraContent.color}`, textAlign: typeExtraContent.align || 'center' }}>{getNickName(memberMobx.memberInfo.nickName)}</div>}
        {type === 'myCoupons_my' && memberMobx.isLogin && !!memberMobx.couponListForUse.length && <div data-cypid='mmgToMy' onClick={() => { handleGo('my') }} style={{ fontSize: `${typeExtraContent.fontSize}px`, color: `${typeExtraContent.color}` }}>{i18n.t('mkt.coupon.couponNum', { cnt: memberMobx.couponListForUse.length })}{typeExtraContent.text}</div>}
        {type === 'myCoupons_get' && memberMobx.isLogin && getCnt > 0 && <div data-cypid='mmgToGetCoupon' onClick={() => { handleGo('get') }} style={{ fontSize: `${typeExtraContent.fontSize}px`, color: `${typeExtraContent.color}` }}>{i18n.t('mkt.coupon.couponNum', { cnt: getCnt })}{typeExtraContent.text}</div>}
        {
          type === 'upgradeTip' && diyMemberCardInfo?.card?.nextLevelInfo &&
            <>
              {
                getDisCount()
                  ? (
                    <div
                      data-cypid='mmgToLvDetail'
                      onClick={handleGoToLvDetail}
                      dangerouslySetInnerHTML={{ __html: i18n.t(`mkt.member.${diyMemberCardInfo?.card?.rechargeGrowthGet && !diyMemberCardInfo?.card?.consumeGrowthGet ? 'moreRechargeTip' : 'moreCostTip'}`, { money: `<span style='color: ${typeExtraContent?.upgradeTipInfo?.varColor}'>${getCost()}</span>`, discount: `<span style='color: ${typeExtraContent?.upgradeTipInfo?.varColor}'>${getDisCount()}</span>`, cardName: diyMemberCardInfo?.card?.nextLevelInfo.cardName }) }}
                      style={{ color: typeExtraContent?.upgradeTipInfo?.color, fontSize: typeExtraContent?.upgradeTipInfo?.fontSize, textAlign: 'center' }}
                    >
                    </div>
                  ) : (
                    <div
                      data-cypid='mmgToLvDetail'
                      onClick={handleGoToLvDetail}
                      dangerouslySetInnerHTML={{ __html: i18n.t(`mkt.member.${diyMemberCardInfo?.card?.rechargeGrowthGet && !diyMemberCardInfo?.card?.consumeGrowthGet ? 'moreRechargeNoDisTip' : 'moreCostNoDisTip'}`, { money: `<span style='color: ${typeExtraContent?.upgradeTipInfo?.varColor}'>${getCost()}</span>`, cardName: diyMemberCardInfo?.card?.nextLevelInfo.cardName }) }}
                      style={{ color: typeExtraContent?.upgradeTipInfo?.color, fontSize: typeExtraContent?.upgradeTipInfo?.fontSize, textAlign: 'center' }}
                    >
                    </div>
                  )
              }
            </>
        }
      </>
    )
  }

  /** 探索门店 */
  const extendStoreDisplayItem = ({ type, style, typeExtraContent }: IDiyModule) => {
    const store = storeMobx.viewStoreList[0] || null
    const pic = format.toPic(store?.storeExtInfo?.storePic)
    return (
      type === 'storeDisplay_img' ? (
        pic.url ? <img className='diy-store-display-img' src={pic.url} /> : null
      ) : type === 'storeDisplay_info' ? (
        <div className='diy-store-display-info'>
          <div className='name-wrap' style={{ color: typeExtraContent?.nameColor || '#161616' }}>{store.storeName}</div>
          <div className='address-wrap'>
            <span className='address' style={{ color: typeExtraContent?.addressColor || '#D6D6D6' }}>{store.address}</span>
            {style.width as number >= 130 && <span className='more'>{i18n.t('store.seeDetails')}</span>}
          </div>
        </div>
      ) : null
    )
  }

  // 渲染扩展组件项
  const handleRenderExtendItem = (data: IDiyModule, index: number) => {
    const { typeExtraContent, type } = data
    const { media, phone } = typeExtraContent || {}
    return (
      <>
        {media?.type === 'img' && <img className='pic' src={media.url} />}
        {media?.type === 'video' && (
          <video
            className='video HomeExtendVideo'
            id={`HomeExtendVideo_${index}`}
            src={media.url}
            poster={`${media.url}?x-oss-process=video/snapshot,t_1000,m_fast`}
            controls
            loop
            muted
            playsInline
            webkit-playsinline='true'
            preload='auto'
          />
        )}
        {phone && <a className='tel' href={`tel:${phone}`}></a>}
        {type.includes('storeDisplay') && authConfigMobx.isNoWorry && extendStoreDisplayItem(data)}
      </>
    )
  }

  // 点击事件
  const handleClick = (data: IDiyModule) => {
    const { module, type, typeExtraContent, uid } = data || {}
    if (module === 'entry') {
      if (['togo', 'dinein', 'pickup', 'delivery', 'buyTogether'].includes(type)) {
        cartMobx.setEatType(type === 'buyTogether' ? 'pickup' : type as TEatType)
        const inStore = restaurantConfig.storeId || (restaurantConfig?.lbs?.lat && restaurantConfig?.lbs?.lng)
        const tt = type === 'buyTogether' ? 'buyTogether' : 'homeEntry'
        if (inStore) {
          history.push('/menu', null, { tt })
        } else {
          history.push('/store', null, { tt })
        }
      } else if (type === 'order') {
        history.push('/menu')
      } else if (type === 'scancode') {
        const { isWeixin, isAlipay } = getPlatform()
        if (Config.codeType === 'brand' && (isWeixin || isAlipay)) {
          if (isAlipay) {
            thirdConfigG().init(() => {
              _handleScan()
            })
          } else {
            _handleScan()
          }
        }
      } else if (type === 'orders') {
        const ordersTab = themeMobx.showTabs?.find(item => item.type === 'orders')
        history.push(ordersTab ? '/orders' : '/orders/2')
      } else if (type === 'member') {
        history.push('/my')
      } else if (type === 'mall') {
        history.push('/mall')
      } else if (type === 'product') {
        history.push(`/recommend/${type}/${uid}/${typeExtraContent?.productTitle || ''}`)
      } else if (type === 'coupon') {
        history.push('/iCoupon')
      } else if (type === 'integralRedeem') {
        history.push('/redeem')
      } else if (type === 'memberCard') {
        let url = '/memberCard'
        if (typeExtraContent.cardId) {
          const hasItem: any = memberMobx.cardList.find((m: any) => m.cardId === typeExtraContent.cardId)
          if (hasItem) {
            const cardInfo = hasItem.card
            if (cardInfo.type === 'paid' && cardInfo.scales.length > 0 && hasItem.expireTime) {
              url = '/iCard/cardOpen/buy/' + hasItem.memberCardId
            } else if ((cardInfo.allowAgainLoad && cardInfo.recharges.length > 0) || cardInfo.allowCustomizeLoad) {
              url = '/iCard/cardRecharge/' + hasItem.memberCardId
            } else {
              url = '/iCard/' + hasItem.cardId
            }
          } else {
            url = '/iCard/cardOpen/open/' + typeExtraContent.cardId
          }
        }
        history.push(url)
      } else if (type === 'giftCard') {
        if (typeExtraContent?.cardId) {
          const hasItem: any = memberMobx.giftCardList.find((m: any) => m.giftcardId === typeExtraContent.cardId && m.status === 'enable')
          if (hasItem && hasItem.giftcard.allowAgainLoad) {
            history.push(`/iGc/recharge/${hasItem.memberCardId}`)
          } else {
            history.push(`/giftCard/buy/${typeExtraContent.cardId}`)
          }
        } else {
          history.push('/giftCard/2')
        }
      } else if (type === 'groupBuy') {
        history.push('/groupBuy')
      } else if (type === 'activityReserve') { // 活动预约
        const activityType = typeExtraContent?.activityType || (data as any)?.activityType
        const activityId = typeExtraContent?.activityId || (data as any)?.activityId
        if (String(activityType || '').toUpperCase() === 'ACTIVITY' && activityId) {
          history.push(`/activityReserve/detail/${activityId}`)
        } else {
          history.push('/activityReserve')
        }
      }
    } else if (module === 'member') {
    } else if (module === 'extend') {
      if (type.includes('storeDisplay')) {
        history.push('/storeDisplay')
      } else {
        const { url } = typeExtraContent || {}
        if (url) location.href = url
      }
    }
  }

  // 滚动播放
  let videoContainer = null
  const handleScroll = useThrottle(function () {
    document.querySelectorAll('.HomeExtendVideo')?.forEach((ele: HTMLVideoElement) => {
      try {
        if (videoContainer && ele !== videoContainer) {
          !ele?.paused && ele?.pause()
          return
        }
      } catch (error) {
        if (videoContainer && ele !== videoContainer) {
          return
        }
      }
      if (checkInVisible(ele)) {
        videoContainer = ele
      } else {
        videoContainer = null
      }
    })
    if (videoContainer) {
      try {
        videoContainer?.paused && videoContainer?.play()
      } catch (error) { }
    }
  }, 100)

  // 页面离开暂停播放
  useIonViewDidLeave(() => {
    document.querySelectorAll('.J_HomeExtendVideo')?.forEach((ele: HTMLVideoElement) => {
      try {
        !ele?.paused && ele?.pause()
      } catch (error) { }
    })
  })

  // mode details
  const diyModeDetails = useMemo(() => {
    return Config.codeType === 'brand' ? homeDecorates?.diyModeDetails?.brandCode : homeDecorates?.diyModeDetails?.storeCode
  }, [homeDecorates, Config])

  // useEffect homeDecorates
  useEffect(() => {
    const cssMap = {
      '--dr-theme-bg-color': Config.codeType === 'brand' ? homeDecorates?.diyModeDetails?.brandCode?.backgroundColor || '#ffffff' : homeDecorates?.diyModeDetails?.storeCode?.backgroundColor || '#ffffff',
    }
    setCSSProperty('.diy-page-content', cssMap)
  }, [homeDecorates])

  useEffect(() => {
    if (memberMobx.isLogin) {
      memberMobx.getUnacquiredCoupons()
    }
    if (!memberCardMobx.cardList.length) {
      memberCardMobx.getCardList()
    }
  }, [])
  return (
    <IonContent
      className='home-page-content diy-page-content'
      scrollEvents
      onIonScroll={handleScroll}
    >
      <LanguageSwitch />
      <div className='home-content-wrapper'>
        <div className='home-bg-wrapper'>
          {availableAdsMap?.home?.length ? <Advert type='home' /> : <Notice type='home' isOnly />}
          {
            diyModeDetails?.backgroundImages?.map((item, index) => (
              <img key={index} className='home-bg-item' style={handleBgStyle(item)} src={item.url} />
            ))
          }
        </div>
        <div className='home-diy-wrapper'>
          {
            diyModeDetails?.modules?.map((item, index) => (
              item?.children?.length ? (
                item.children.map((child, childIndex) => (
                  <div data-cypid='diyModuleChildItem' key={`${index}_${childIndex}`} className='home-diy-item' style={diyStyle(child?.style, index)} onClick={() => handleClick(child)}>
                    {item.module === 'member' && handleRenderMemberItem(child, index)}
                    {item.module === 'extend' && handleRenderExtendItem({
                      ...child,
                      typeExtraContent: {
                        ...((!!item.type.includes('storeDisplay') && item.typeExtraContent) || {}),
                        ...(child.typeExtraContent || {}),
                      }
                    }, index)}
                  </div>
                ))
              ) : (
                <div data-cypid='diyModuleItem' key={index} className='home-diy-item' style={diyStyle(item?.style, index)} onClick={() => handleClick(item)}>
                  {item.module === 'member' && handleRenderMemberItem(item, index)}
                  {item.module === 'extend' && handleRenderExtendItem(item, index)}
                </div>
              )
            ))
          }
        </div>
      </div>
    </IonContent>
  )
}

export default observer(HomeDiy)
